<template>
  <div class="container" style="display: flex; justify-content: center; align-items: center; height: 100%">
    <div class="login" style="max-width: 500px;border: 1px solid #dadada; border-radius: 10px; margin-top: 250px">
      <a-divider style="margin-top: 40px">{{ loginTitle }}</a-divider>
      <a-form
        v-if="isLogin"
        style=""
        @submit="loginSubmit" :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          label='手机号'
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          fieldDecoratorId="username"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '用户名不能为空' }]}"
          style="width: 500px"
        >
          <a-input placeholder="请输入手机号" v-model="username">
            <a-icon slot="prefix" type="user"/>
          </a-input>
        </a-form-item>
        <a-form-item
          label='密码'
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          fieldDecoratorId="pwd"
          help="密码必须包含数字、字母，长度为 8-16"
          :fieldDecoratorOptions="{validateTrigger: 'blur', rules: [{ required: true, message: '密码不能为空'}, {pattern: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$', message: '密码必须包含数字、字母，长度为 8-16'}]}"
        >
          <a-input placeholder="请输入密码" type='password' v-model="password">
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <p v-show="loginRes.length" style="color: red; margin-left: 145px">{{ loginRes }}</p>
        <a-form-item
          :wrapperCol="{ span: 12, offset: 5 }"
        >
          <a-button type='primary' htmlType='submit' style="display: inline; margin-left: 55px">
            登录
          </a-button>
          <a-button type='primary' @click="goRegist" style="display: inline; margin-left: 55px">
            注册
          </a-button>
        </a-form-item>
      </a-form>
      <a-form
        v-else
        style=""
        @submit="registSubmit" :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          label='手机号'
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          fieldDecoratorId="username"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '用户名不能为空' }]}"
          style="width: 500px"
        >
          <a-input placeholder="仅限部分手机号可以注册" v-model="username">
            <a-icon slot="prefix" type="user"/>
          </a-input>
        </a-form-item>
        <a-form-item
          label='密码'
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          fieldDecoratorId="pwd"
          help="密码必须包含数字、字母，长度为 8-16"
          :fieldDecoratorOptions="{validateTrigger: 'blur', rules: [{ required: true, message: '密码不能为空'}, {pattern: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$', message: '密码必须包含数字、字母，长度为 8-16'}]}"
        >
          <a-input placeholder="请输入密码" type='password' v-model="password">
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item
          label='确认密码'
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          fieldDecoratorId="pwdAgain"
          :fieldDecoratorOptions="{validateTrigger: 'blur', rules: [{ required: true, message: '密码不能为空'}, { validator: this.confirmPassword }]}"
        >
          <a-input placeholder="重复密码" type='password' v-model="passwordAgain">
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <p v-show="registRes.length" style="color: red; margin-left: 145px">{{ registRes }}</p>
        <a-form-item
          :wrapperCol="{ span: 12, offset: 5 }"
        >
          <a-button type='primary' @click="goLogin" style="display: inline; margin-left: 55px">
            登录
          </a-button>
          <a-button type='primary' htmlType='submit' style="display: inline; margin-left: 55px">
            注册
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import '../config/global'
const axios = require('axios')
export default {
  name: 'Login',
  // components: [AFormItem, AForm],
  data () {
    return {
      loginUrlPostfix: 'ULogin/login',
      registUrlPostfix: 'ULogin/regist',
      verifyTokenUrlPostfix: 'verify_token',
      labelCol: { span: 7 },
      wrapperCol: { span: 12 },
      username: '',
      password: '',
      passwordAgain: '',
      loginRes: '',
      registRes: '',
      isLogin: true,
      loginTitle: '登录'
    }
  },
  computed: {
    loginUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.loginUrlPostfix
    },
    registUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.registUrlPostfix
    },
    verifyTokenUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.verifyTokenUrlPostfix
    }
  },
  created () {
    this.verifyToken()
  },
  methods: {
    verifyToken () {
      if (sessionStorage.token) {
        axios.post(this.verifyTokenUrl, {
          token: sessionStorage.token
        }).then((data) => {
          if (data.data.err_code === 0) {
            // login success
            sessionStorage.token = data.data.content.token
            this.$router.push('/MainLayout')
          } else if (data.data.err_code === 50002) {
            this.$router.push('/')
          }
        })
      } else {
        this.$router.push('/')
      }
    },
    loginSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          axios.post(this.loginUrl, {
            username: this.username,
            password: this.password
          }).then((data) => {
            if (data.data.err_code === 0) {
              // login success
              sessionStorage.token = data.data.content.user.token
              this.loginRes = '登录成功'
              this.$router.push('/MainLayout')
            } else if (data.data.err_code === 50001) {
              this.loginRes = '用户名或密码错误'
              this.password = ''
            }
          })
        }
      })
    },
    registSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          axios.post(this.registUrl, {
            username: this.username,
            password: this.password
          }).then((data) => {
            if (data.data.err_code === 0) {
              // login success
              sessionStorage.token = data.data.content.user.token
              this.registRes = '注册成功，正在跳转登录'
              this.$router.push('/ChatroomManage')
            } else if (data.data.err_code === 20029) {
              this.registRes = '手机号已注册'
              this.password = ''
              this.passwordAgain = ''
            } else if (data.data.err_code === 20003) {
              this.registRes = '该手机号暂不能注册'
              this.password = ''
              this.passwordAgain = ''
            }
          })
        }
      })
    },
    confirmPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('pwd')) {
        callback('确认密码要和密码相同！')
      } else {
        callback()
      }
    },
    goRegist () {
      this.isLogin = false
      this.loginTitle = '注册'
    },
    goLogin () {
      this.isLogin = true
      this.loginTitle = '登录'
    }
  }
}
</script>
